import PageBreadcrumb from './PageBreadcrumb';

export default PageBreadcrumb;
